import { PropertyFilterProps } from '@amzn/awsui-components-react/polaris/property-filter';
import { usePropertyFilterStrings } from '../../../hooks/localization/propertyFilterStrings';
import { TablePropertyFilter } from '../wizard/tablePropertyFilter';
import { useCsvFilterProperties, useCsvFilteringOptions } from '../wizard/tablePropertyFilter';

export type PeoplePropertyFilterProps = {
  query: PropertyFilterProps.Query;
  onChange: NonNullable<PropertyFilterProps['onChange']>;
};

export function PeoplePropertyFilter(props: PeoplePropertyFilterProps) {
  const namespaces = ['attendance', 'translation'];
  const propertyFilterStrings = usePropertyFilterStrings('propertyFilter', namespaces);
  const filteringProperties = useCsvFilterProperties();
  const filteringOptions = useCsvFilteringOptions();

  return (
    <TablePropertyFilter
      {...props}
      query={props.query}
      propertyFilterStrings={propertyFilterStrings}
      // GOLDEN PATH NOTE
      // We do pre-processing of the tokens here, so that any values that the component generates are fully cleaned
      // and can be used as-is in other hooks/components
      onChange={({ detail }) => {
        const flattenedTokens = detail.tokens.flatMap((token) => {
          // If we have previously processed a complex token, or if the user has typed in a simple token, we can just use it as is
          if (!token.value.includes(',') && token.value.trim() !== '') return token;

          // If the user enters a complex token we need to post-process into seperate tokens
          // A complex token can be a search term with commas, which indicates it is actually multiple search terms
          // or it can be a blank token (ie only whitespace), or a combination of the two
          return token.value
            .split(',')
            .filter((tokenValue: string) => tokenValue.trim() !== '')
            .map((tokenValue: string) => ({
              value: tokenValue.trim(),
              propertyKey: token.propertyKey,
              operator: token.operator,
            }));
        });
        props.onChange(
          new CustomEvent('onPeoplePropertyFilterChange', {
            detail: {
              tokens: flattenedTokens,
              operation: 'or',
            },
          })
        );
      }}
      filteringOptions={filteringOptions}
      filteringProperties={filteringProperties}
    />
  );
}
